import { FC, Fragment, useCallback, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDidMount } from "rooks";
import TabContext from "@mui/lab/TabContext";
import { TabPanel } from "@mui/lab";
import { AzureReservationCoverageDrawerContentHeaderInfoCards } from "./AzureReservationCoverageDrawerContentHeaderInfoCards";
import { CommitmentsDrawerHeader } from "../../../../../common/components/drawer/header/CommitmentsDrawerHeader";
import { azureReservationSelectedCoverageDataRegionSelector } from "@/store/commitments/selectors/azure/reservations/details-drawer/resource-type/azureReservationSelectedCoverageDataRegionSelector";
import { azureReservationSelectedCoverageDataAccountNameAndIdSelector } from "@/store/commitments/selectors/azure/reservations/details-drawer/resource-type/azureReservationSelectedCoverageDataAccountNameAndIdSelector";
import { getAzureReservationDetailsThunk } from "@/store/commitments/thunks/azure/reservations/getAzureReservationDetailsThunk";
import { commitmentsDetailsDrawerTargetTypeSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetTypeSelector";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { azureReservationSelectedCoverageDataResourceTypeSelector } from "@/store/commitments/selectors/azure/reservations/details-drawer/resource-type/azureReservationSelectedCoverageDataResourceTypeSelector";
import { commitmentsResourceTypeNames } from "@/components/pages/commtiments/common/utils/constants/labels";
import { CommitmentDrawerTabType } from "@/components/pages/commtiments/common/components/drawer/utils/constants";
import { CommitmentDrawerTabs } from "@/components/pages/commtiments/common/components/drawer/CommitmentDrawerTabs";
import { AzureReservationCoverageDrawerCoverageTab } from "@/components/pages/commtiments/azure/reservations/components/drawers/coverage-drawer/AzureReservationCoverageDrawerCoverageTab";

interface AzureReservationCoverageDrawerContentProps {
  onClose(): void;
}

export const AzureReservationCoverageDrawerContent: FC<
  AzureReservationCoverageDrawerContentProps
> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const [tab, setTab] = useState("coverage");

  const accountId = useAppSelector(
    azureReservationSelectedCoverageDataAccountNameAndIdSelector,
  );
  const resourceType = useAppSelector(
    azureReservationSelectedCoverageDataResourceTypeSelector,
  );
  const region = useAppSelector(
    azureReservationSelectedCoverageDataRegionSelector,
  );
  const targetType = useAppSelector(commitmentsDetailsDrawerTargetTypeSelector);

  const title = useMemo(() => {
    if (targetType === "region") {
      return region ?? "Region";
    }
    if (targetType === "resource_type") {
      if (resourceType) {
        return commitmentsResourceTypeNames[resourceType] ?? resourceType;
      }

      return "Resource Type";
    }
    return accountId;
  }, [accountId, targetType, region, resourceType]);

  const label = useMemo(() => {
    if (targetType === "region") {
      return "Region Coverage:";
    }
    if (targetType === "resource_type") {
      return "Resource Type Coverage:";
    }
    return "Subscription Coverage:";
  }, [targetType]);

  const tabChangeHandler = useCallback((tab: CommitmentDrawerTabType) => {
    setTab(tab);
  }, []);

  useDidMount(() => {
    dispatch(getAzureReservationDetailsThunk());
  });
  return (
    <Fragment>
      <CommitmentsDrawerHeader title={title} onClose={onClose} label={label}>
        {targetType === "resource_type" && (
          <AzureReservationCoverageDrawerContentHeaderInfoCards />
        )}
      </CommitmentsDrawerHeader>
      <Box bgcolor="grey.50" height="100%">
        <TabContext value={tab}>
          <CommitmentDrawerTabs onTabChange={tabChangeHandler} tabs={tabs} />
          <TabPanel value="coverage" sx={{ p: 0, flex: 1 }}>
            <AzureReservationCoverageDrawerCoverageTab />
          </TabPanel>
        </TabContext>
      </Box>
    </Fragment>
  );
};

const tabs = [
  {
    value: "coverage",
    label: (
      <Typography variant="body2" fontWeight="medium">
        Coverage
      </Typography>
    ),
  },
];
